/**
 * 获取当前可见的全屏详情页弹窗容器
 * 由于可能有多个弹窗堆叠，需要获取当前可见的那个
 */
export function getPinDetailModal() {
  // 查找所有弹窗
  const allModals = document.querySelectorAll(".pinDetailModal");

  if (allModals.length === 0) {
    return null;
  }

  // 如果只有一个，直接返回
  if (allModals.length === 1) {
    return allModals[0];
  }

  // 多个弹窗时，找到可见的那个（最上层，不是 hidden 的）
  for (let i = allModals.length - 1; i >= 0; i--) {
    const modal = allModals[i];
    const computedStyle = window.getComputedStyle(modal);
    if (
      computedStyle.display !== "none" &&
      computedStyle.visibility !== "hidden"
    ) {
      return modal;
    }
  }

  // 兜底返回最后一个
  return allModals[allModals.length - 1];
}

/**
 * 检查是否在弹窗模式下
 */
export function isInPinDetailModal() {
  return !!document.querySelector(".pinDetailModal");
}
